import type {Step} from "./Step.ts";
import type {Setter} from "../../util/setter/Setter.ts";
import type {PropsWithChildren} from "react";
import Styles from "./Styles.module.scss"
import {Typography} from "@matillion/component-library";
import {combineStyles} from "../../util/combineStyles.ts";

interface Props {
    steps: Step[]
    currentStep: number
    setCurrentStep: Setter<number>
    locked: boolean
}
export function StepArrows({steps, currentStep, setCurrentStep, children, locked}: PropsWithChildren<Props>) {
    const prevAvailable = currentStep > 0
    const nextExists = currentStep < steps.length - 1
    const nextAvailable = !locked && currentStep < steps.length - 1 && steps[currentStep + 1].isAvailable
    return <div className={Styles.StepArrows}>
        {prevAvailable &&
            <div
                className={combineStyles(Styles.Arrow, Styles.Arrow_Left, locked ? Styles.Arrow_Disabled : Styles.Arrow_Enabled)}
                onClick={() => setCurrentStep(currentStep - 1)}
            >
                <Typography format="bcl">‹</Typography>
                <Typography format="bcm">Previous</Typography>
            </div>
        }
        {children}
        {nextExists &&
            <div
                className={combineStyles(Styles.Arrow, Styles.Arrow_Right, nextAvailable ? Styles.Arrow_Enabled : Styles.Arrow_Disabled)}
                onClick={() => setCurrentStep(currentStep + 1)}
            >
                <Typography format="bcl">›</Typography>
                <Typography format="bcm">Next</Typography>
            </div>
        }
    </div>
}